module.exports = __webpack_public_path__ + "img/cloudcheckbg.05b0e57c.png";